import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const PaymentsAndDeductionsHeader = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.PaymentsDeductions);

  return (
    <Stack direction='column' gap={isDesktop ? '16px' : '8px'}>
      <Typography variant={'h2'} color={'text.secondary'}>
        {dictionary.title}
      </Typography>
      <Typography variant={'body3'} color={'text.secondary'}>
        {dictionary.subTitle}
      </Typography>
    </Stack>
  );
};
